export default () => [
  {
    title: "Planera ärende",
    key: "PLAN",
    visited: true,
    hasError: false,
    fieldKeys: ["expected_duration", "planned_start", "planned_end"],
  },
];
